// import {
//     IonCol,
//     IonContent,
//     IonPage,
//     IonRow,
//     IonButton,
//     IonLabel,
//     IonInput,
//     IonImg,
//     IonText,
//     IonItemDivider,
//     IonLoading,
//     IonSearchbar,
//     IonIcon,
//     useIonAlert
// } from "@ionic/react";
// import React, { useEffect, useState, useMemo, useRef } from "react";
// import { Modal } from "react-bootstrap";
// import Head from "../Head";
// import Foot from "../Foot";
// import Authservice from "../../Services/user.service";
// import { useHistory } from "react-router";
// import DataTable from "react-data-table-component";
// import moment from "moment";
// import { Capacitor } from "@capacitor/core";
// import AdminHead from "./adminHead";
// import Sidebar from "./sidebar";
// import customTableStyle from "../../components/CustomTableStyle";
// import { close } from "ionicons/icons";

// import { saveAs } from 'file-saver';

// const Donationmanage: React.FC = () => {
//     const [usertoken] = useState(sessionStorage.getItem("token"));
//     const userdata: any = useState(sessionStorage.getItem("UserData"));
//     const uFlag: any = useState(sessionStorage.getItem("uFlag"));
//     const [filterText, setFilterText] = React.useState("");
//     const [donor, setDonor] = useState([]);
//     const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
//     const [modalopen, setModalopen] = useState(false);
//     const [index, setIndex] = useState(0);
//     const [donorname, setDonorname] = useState();
//     const [donornumber, setDonornumber] = useState();
//     const [donationnumber, setDonationnumber] = useState();
//     const [mail, setMail] = useState();
//     const [purpose, setPurpose] = useState();
//     const [date, setDate]: any = useState();
//     const [number, setNumber] = useState();
//     const [addr, setAddr] = useState();
//     const [remark, setRemark]: any = useState("");
//     const [Contribution, setContribution]: any = useState();
//     const [showLoading, setShowLoading] = useState(false);
//     const history = useHistory();
//     const [Alert] = useIonAlert();
//     if (donor != undefined && donor.length > 0) {
//         donor.forEach((item: any, index: any) => { item.serial = index + 1; });
//         donor.forEach((item: any, index: any) => {
//             var date = item.donationDate.split("T");
//             const od = moment(date[0]).format("DD-MM-YYYY");
//             item.localOrderDate = od;
//         });
//     }


//     const formatter = new Intl.NumberFormat('en-IN')

//     useEffect(() => {

//         if (userdata[0] === null) {
//             history.push("/login")
//         }
//         else if (userdata[0] !== "ROLE_ADMIN") {
//             history.push("/home")
//         }
//         else if (uFlag[0] === "false") {
//             history.push("/home")
//         }
//         else {
//             Donationadm()
//         }
//     }, [])
//     const downLoadReport = () => {
//         setShowLoading(true);
//         Authservice.downLoadReport(usertoken).then((response) => {
//             console.log(response);



//   // Decode the base64 string
//   const decodedData = atob(response.data);
//   const filename = "donation"+new Date()+".xlsx";

//   // Convert the decoded data to a Uint8Array
//   const uint8Array = new Uint8Array(decodedData.length);
//   for (let i = 0; i < decodedData.length; i++) {
//     uint8Array[i] = decodedData.charCodeAt(i);
//   }

//   // Convert the Uint8Array to a Blob
//   const blob = new Blob([uint8Array], { type: 'application/octet-stream' });

//   // Use FileSaver.js to save the Blob as a file
//   saveAs(blob, filename);
//            setShowLoading(false);
//         }) .catch((error) => {
//             setShowLoading(false);
//             Alert("Something went wrong, please try again later.")

//         });

//       //  const base64String = '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'; // Your base64 string here


//     }

//     const Donationadm = () => {
//         setShowLoading(true);
//         Authservice.Donationmanage(usertoken).then((response) => {
//             console.log(response);
//             setDonor(response.data);
//             setShowLoading(false);
//         })
//     }

//     const viewdetails = (item: any) => {
//         var date1 = item.donationDate.split("T");
//         const od1 = moment(date1[0]).format("DD-MM-YYYY");
//         setDonorname(item.donorName);
//         setDonationnumber(item.donationNumber);
//         setContribution(item.contributionAmount);
//         setDate(od1);
//         setNumber(item.contactNumber);
//         setAddr(item.address);
//         setMail(item.emailId);
//         setPurpose(item.purpose);
//         if (item.remarks === "" || item.remarks === null) {
//             setRemark("NA")
//         } else {
//             setRemark(item.remarks)
//         }
//         setModalopen(true);
//     };

//     const columns: any = [
//         {
//             name: "S.No",
//             selector: (item: any, i: any) => item.serial,
//             width: "90px",
//             sortable: true,
//             cell: (item: any) => (
//                 <div className="center_col_tab" onClick={() => viewdetails(item)}>
//                   {item.serial}
//                 </div>
//               ),
//         },

//         {
//             name: "Donation Number",
//             selector: (item: any) => item.donationNumber,
//             sortable: true,
//             // width: "150px",
//             cell: (item: any) => (
//                 <div className="center_col_tab" onClick={() => viewdetails(item)}>
//                     <IonText style={{ cursor: "pointer" }} >{item.donationNumber}</IonText>
//                 </div>
//             )
//         },
//         {
//             name: "Donor Name",
//             selector: (item: any) => item.donorName,
//             sortable: true,
//             // width: "150px",
//             cell: (item: any) => (
//                 <div className="left_col" onClick={() => viewdetails(item)} style={{textAlign:"end"}}>
//                     <div style={{ cursor: "pointer" }} >{item.donorName}</div>
//                 </div>
//             ),

//         },

//         {
//             name: "Contribution Amount (₹)",
//             selector: (item: any) => parseInt(item.contributionAmount, 10),
//             sortable: true,
//             // width: "200px",
//             cell: (item: any) => (
//                 <div className="center_col_tab" onClick={() => viewdetails(item)}>
//                     <IonText style={{ cursor: "pointer" }} >{formatter.format(item.contributionAmount)}</IonText>
//                 </div>
//             ),
//         },
//         {
//             name: "Donation Date",
//             selector: (item: any) => new Date(item.localOrderDate.split('-').reverse().join('-')),
//             sortable: true,
//             // width: "150px",
//             cell: (item: any) => (
//                 <div className="center_col_tab" onClick={() => viewdetails(item)}>
//                     <div style={{ cursor: "pointer" }} >{item.localOrderDate}</div>
//                 </div>
//             ),
//         },

//         {
//             name: "Purpose",
//             selector: (item: any) => item.purpose,
//             sortable: true,
//             // width: "200px",
//             cell: (item: any) => (
//                 <div className="left_col" onClick={() => viewdetails(item)}>
//                     <div style={{ cursor: "pointer" }}  >{item.purpose}</div>
//                 </div>
//             ),
//         },
//         // {
//         //     name: "View",
//         //     sortable: false,

//         //     cell: (item: any) => (
//         //         <>
//         //             <IonButton onClick={() => viewdetails(item)} style={{ textTransform: "none" }}>View</IonButton>
//         //         </>
//         //     )
//         // }
//     ]

//     var tableData: any = [];

//     if (donor != undefined && donor.length > 0) {
//         tableData = donor.filter(
//             (item: any) =>
//                 JSON.stringify(item)
//                     .toLowerCase()
//                     .indexOf(filterText.toLowerCase()) !== -1
//         );
//     }


//     const paginationComponentOptions = {
//         selectAllRowsItem: true,
//         selectAllRowsItemText: "ALL"
//     };

//     const subHeaderComponent = useMemo(() => {
//         const handleClear = () => {
//             if (filterText) {
//                 setResetPaginationToggle(!resetPaginationToggle);
//                 setFilterText("");
//             }
//         }
//         return (
//             <IonRow className="table_btn_container">
//                  <div>
//                     <IonButton onClick={downLoadReport} className="admin_add_btn">

//                         <span>Report</span>

//                     </IonButton>

//                 </div>

//                 <div>
//                     <IonSearchbar style={{ paddingRight: '0px' }}
//                         value={filterText}
//                         onIonChange={(e: any) => setFilterText(e.detail.value)}
//                         placeholder="Search"
//                         className="table_search"
//                     />
//                 </div>
//             </IonRow>
//         );
//     }, [filterText, resetPaginationToggle]);

//     const Modalclose = () => {
//         setModalopen(false)
//     }
//     const useOutsideAlerter = (refer: any) => {
//         useEffect(() => {
//             function handleClickOutside(event: any) {
//                 if (refer.current && !refer.current.contains(event.target)) {
//                     setModalopen(false)
//                 }
//             }
//             document.addEventListener("mousedown", handleClickOutside);
//             return () => {
//                 document.removeEventListener("mousedown", handleClickOutside);
//             }
//         }, [refer]);
//     }
//     const donationmodal = useRef(null);
//     useOutsideAlerter(donationmodal);

//     return (
//         <IonPage>
//              <AdminHead User={"user"} Role={"Role"} Name={"Donation Management"} />
//       <Sidebar />
//             <IonContent>
//                 <IonLoading message="Loading..." spinner={null}
//                     isOpen={showLoading}
//                 // onDidDismiss={() => setShowLoading(false)}
//                 // duration={5000}
//                 />
//                 {/* <Head User="deity" Role={userdata[0]} /> */}

//                 <Modal show={modalopen} className="modal_dialog_width1 centered-modal-matmanagement">
//                     <Modal.Body ref={donationmodal}>
//                         <div className="modal-header">
//                             <h5 className="modal-title">Donor Details</h5>
//                             <div>
//                   <IonIcon src={close} className="donation-modal-close-icon close_icon" onClick={() => setModalopen(false)} />
//                 </div>

//                         </div>
//                         <div style={{padding:"0px 20px"}}>
//                             {donorname === "" || donorname == null ? <></> :
//                                 <IonRow className="row_bot" style={{ marginTop: "4%" }}>
//                                     <IonCol size="5">
//                                         <IonLabel style={{ fontWeight: "bolder" }}>
//                                             Donor Name
//                                         </IonLabel>
//                                     </IonCol>
//                                     <IonCol size="7" >
//                                         <IonText style={{ paddingRight: "2%" }}>:</IonText>
//                                         <IonText >{donorname}</IonText>
//                                     </IonCol>
//                                 </IonRow>}
//                             <IonRow className="row_bot" style={{ marginTop: (donorname === "" ? "4%" : "0%") }}>
//                                 <IonCol size="5">
//                                     <IonLabel style={{ fontWeight: "bolder" }} >
//                                         Donation Number
//                                     </IonLabel>
//                                 </IonCol>
//                                 <IonCol size="7">
//                                     <IonText style={{ paddingRight: "2%" }}>:</IonText>
//                                     <IonText

//                                     >{donationnumber}</IonText>
//                                 </IonCol>
//                             </IonRow>
//                             <IonRow className="row_bot">
//                                 <IonCol size="5">
//                                     <IonLabel style={{ fontWeight: "bolder" }} >
//                                         Contribution Amount (₹)
//                                     </IonLabel>
//                                 </IonCol>
//                                 <IonCol size="7">
//                                     <IonText style={{ paddingRight: "2%" }}>:</IonText>
//                                     <IonText

//                                     >{formatter.format(Contribution)}</IonText>
//                                 </IonCol>
//                             </IonRow>
//                             <IonRow className="row_bot">
//                                 <IonCol size="5">
//                                     <IonLabel style={{ fontWeight: "bolder" }} >
//                                         Donation Date
//                                     </IonLabel>
//                                 </IonCol>
//                                 <IonCol size="7">
//                                     <IonText style={{ paddingRight: "2%" }}>:</IonText>
//                                     <IonText

//                                     >{date}</IonText>
//                                 </IonCol>
//                             </IonRow>
//                             {number === "" || number == null ? <></> :
//                                 <IonRow className="row_bot">
//                                     <IonCol size="5">
//                                         <IonLabel style={{ fontWeight: "bolder" }} >
//                                             Contact Number
//                                         </IonLabel>
//                                     </IonCol>
//                                     <IonCol size="7">
//                                         <IonText style={{ paddingRight: "2%" }}>:</IonText>
//                                         <IonText

//                                         >{Authservice.formatPhone(number)}</IonText>
//                                     </IonCol>
//                                 </IonRow>}
//                             {mail === "" || mail == null ? <></> :
//                                 <IonRow className="row_bot">
//                                     <IonCol size="5">
//                                         <IonLabel style={{ fontWeight: "bolder" }} >
//                                             Email Id
//                                         </IonLabel>
//                                     </IonCol>
//                                     <IonCol size="7">
//                                         <IonText style={{ paddingRight: "2%" }}>:</IonText>
//                                         <IonText

//                                         >{mail}</IonText>
//                                     </IonCol>
//                                 </IonRow>}
//                             {addr === "" || addr == null ? <></> :
//                                 <IonRow className="row_bot">
//                                     <IonCol size="5">
//                                         <IonLabel style={{ fontWeight: "bolder" }} >
//                                             Address
//                                         </IonLabel>
//                                     </IonCol>
//                                     <IonCol size="7">
//                                         <IonText style={{ paddingRight: "2%" }}>:</IonText>
//                                         <IonText>{addr}</IonText>
//                                     </IonCol>
//                                 </IonRow>}
//                             <IonRow className="row_bot">
//                                 <IonCol size="5">
//                                     <IonLabel style={{ fontWeight: "bolder" }} >
//                                         Purpose
//                                     </IonLabel>
//                                 </IonCol>
//                                 <IonCol size="7">
//                                     <IonText style={{ paddingRight: "2%" }}>:</IonText>
//                                     <IonText>{purpose}</IonText>
//                                 </IonCol>
//                             </IonRow>
//                             <IonRow className="row_bot">
//                                 <IonCol size="5">
//                                     <IonLabel style={{ fontWeight: "bolder" }} >
//                                         Remarks
//                                     </IonLabel>
//                                 </IonCol>
//                                 <IonCol size="7">
//                                     <IonText style={{ paddingRight: "2%" }}>:</IonText>
//                                     <IonText

//                                     >{remark}</IonText>
//                                 </IonCol>
//                             </IonRow>
//                             <IonRow className="row_bot">
//                                 <IonCol size="11" size-lg="7" style={{ textAlign: 'center' }}>
//                                     <IonButton className="admin_add_btn"

//                                         onClick={Modalclose}
//                                     >
//                                         <span className="button_padding"> Close

//                                         </span>

//                                     </IonButton>
//                                 </IonCol>
//                             </IonRow>
//                         </div>
//                     </Modal.Body>
//                 </Modal>

//                 {index == 0 ? <div className="container_middle_table page-wrapper admin_background_color">

//                     <div className="data_table">

//                         <DataTable
//                             columns={columns}
//                             data={tableData}
//                             striped
//                             noDataComponent="Sorry ! No result found"
//                             pagination
//                             paginationComponentOptions={paginationComponentOptions}
//                             paginationRowsPerPageOptions={[10, 25, 50, 75, 100]}
//                             subHeader
//                             subHeaderComponent={subHeaderComponent}
//                             onRowClicked={(item: any) => viewdetails(item)}
//                             customStyles={customTableStyle}
//                         />
//                         </div></div> : <></>}


//             </IonContent>
//         </IonPage >
//     )
// }

// export default Donationmanage;


import { useEffect } from 'react';

declare global {
    interface Window {
        Tawk_API?: any;
    }
}

const TawkToWidget = () => {
    useEffect(() => {
        // Check if the script is already added to prevent duplicate inserts
        if (!window.Tawk_API) {
            var Tawk_API: any = Tawk_API || {}, Tawk_LoadStart = new Date();
            (function () {
                var s1 = document.createElement("script");
                s1.async = true;
                s1.src = 'https://embed.tawk.to/677781a6af5bfec1dbe609e8/1igld4tcd';
                s1.charset = 'UTF-8';
                s1.setAttribute('crossorigin', '*');
                var s0: any = document.getElementsByTagName('script')[0];
                s0.parentNode.insertBefore(s1, s0);
            })();
        }
    }, []);

    return null; // No UI needed for the widget
};

export default TawkToWidget;
